import React from "react";
import clipboardBlack from "../../assets/image/clipboardBlack.svg";


export default function OrdersCard({dashData}) {

    const orderStats = [
        { label: "total", value: dashData.allOrders, color: "text-gray-800" },
        { label: "confirmed", value: dashData.acceptedOrders, color: "text-blue-900" },
        { label: "delivered", value: dashData.completedOrders, color: "text-green-700" },
        { label: "denied", value: dashData.rejectedOrders, color: "text-red-800" },
    ];

  return (
    <div className="col-span-3 w-full font-inter bg-[#efe5df] rounded-[30px] p-6 flex flex-col gap-8 shadow-sm h-auto min-h-[150px] md:col-span-1 md:w-full">
      <div className="flex items-center gap-2">
        <img src={clipboardBlack} className="w-9 h-9" />

        <h2 className="text-3xl font-semibold text-[#1f1b18]">Orders</h2>
      </div>

      <div className="flex flex-col gap-8 mt-2  ">
        {orderStats.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center py-3 px-0 text-2xl font-inter text-[#938E8C]"
          >
            <div className="flex items-center gap-2 ">
              <div className="w-1.5 h-1.5 rounded-full bg-[#938E8C]"></div>
              <span>{item.label}</span>
            </div>
            <span
              className={` font-bold text-2xl underline decoration-2 underline-offset-4 ${item.color}`}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
